module.exports = __webpack_public_path__ + "static/model-brain.dc55eaa1.jpg";